export default {
  "HitPaw Online Audio Extractor": "HitPaw Online Audio Extractor",
  "Extract sound from videos with ease.": "Extract sound from videos with ease.",
  "Select Audio Format": "Select Audio Format",
  "Extract Audio": "Extract Audio",
  "Extracting Audio": "Extracting Audio",
  "Extracted Successfully": "Extracted Successfully",
  "Extract New": "Extract New",
  "Extraction Failed": "Extraction Failed",
  "Format": "Format",
};
